import { twMerge } from "tailwind-merge";
import { RecurrenceButton } from "@/components/atoms/RecurrenceButton";
import { updateRecurrenceButtons } from "./functions/updateRecurrenceButtons";
import type { TProps } from "./types";

export const RecurrenceCards = ({
  onClickChangeRecurrence,
  allRecurrenceCards,
  benefits = [],
  benefitsProps,
  onClickAlterarPlano,
}: TProps) => {
  const root = document.createElement("div");
  root.className = "flex flex-col gap-4 w-full max-w-[550px]";

  const bar = document.createElement("div");
  bar.className = "w-full flex bg-blue-50 rounded-md p-1 justify-between";

  allRecurrenceCards.forEach((buttonProps, index) => {
    const handleClickRecurrenceButton = (event: MouseEvent) => {
      const target = event.currentTarget as HTMLButtonElement;
      updateRecurrenceButtons({ target, action: "active" });

      bar.querySelectorAll("button").forEach((el) => {
        if (el !== target)
          updateRecurrenceButtons({
            target: el as HTMLButtonElement,
            action: "inactive",
          });
      });

      onClickChangeRecurrence(buttonProps.id);
    };

    bar.appendChild(
      RecurrenceButton({
        ...buttonProps,
        active: index === 0,
        onClick: handleClickRecurrenceButton,
      }),
    );
  });
  root.appendChild(bar);

  const toggleBtn = document.createElement("button");
  root.appendChild(toggleBtn);

  const expanded = document.createElement("div");
  expanded.className = "hidden flex-col gap-6";
  root.appendChild(expanded);

  if (benefits.length) {
    const aboutWrap = document.createElement("section");
    aboutWrap.className = "flex flex-col gap-3";

    const title = document.createElement("h3");
    title.className = "text-sm font-normal text-gray-450";
    title.textContent = "Sobre o plano";
    aboutWrap.appendChild(title);

    const list = document.createElement("div");
    list.className = "flex flex-col gap-2";

    benefits.forEach((benefit) => {
      const row = document.createElement("div");
      row.className = "flex items-start gap-4";

      const icon = document.createElement("img");
      icon.src = benefitsProps?.verifiedImage.src || "";
      icon.alt = benefitsProps?.verifiedImage.alt || "";
      icon.className = "w-5 h-5 object-contain";

      const text = document.createElement("p");
      text.className = twMerge(
        "font-normal text-gray-800 text-sm",
        benefitsProps?.verifiedTextClass,
      );
      text.textContent = benefit;

      row.appendChild(icon);
      row.appendChild(text);
      list.appendChild(row);
    });

    aboutWrap.appendChild(list);
    expanded.appendChild(aboutWrap);
  }

  const footerBleed = document.createElement("div");
  footerBleed.className = "-mx-4 border-t border-gray-100 pt-3";

  const footerActions = document.createElement("div");
  footerActions.className = "flex px-4 items-center justify-center";

  const alterarPlanoBtn = document.createElement("button");
  alterarPlanoBtn.type = "button";
  alterarPlanoBtn.className = twMerge(
    "inline-flex items-center gap-2",
    "text-blue-480 font-normal text-center",
    "hover:opacity-90 active:opacity-95 transition-opacity cursor-pointer",
  );

  const alterarIcon = document.createElement("img");
  alterarIcon.src = "/static/icons/arrow-left-right.svg";
  alterarIcon.alt = "Alternar plano";
  alterarIcon.className = "w-5 h-5 object-contain";

  const alterarLabel = document.createElement("span");
  alterarLabel.textContent = "Alterar plano";

  alterarPlanoBtn.appendChild(alterarIcon);
  alterarPlanoBtn.appendChild(alterarLabel);

  if (typeof onClickAlterarPlano === "function") {
    alterarPlanoBtn.addEventListener("click", () => onClickAlterarPlano());
  }

  footerActions.appendChild(alterarPlanoBtn);
  footerBleed.appendChild(footerActions);
  expanded.appendChild(footerBleed);

  toggleBtn.classList.add("ds-toggle-recurrence");
  root.setAttribute("data-ds-expanded", "false");

  const toggleExpanded = () => {
    const isHidden = expanded.classList.contains("hidden");
    if (isHidden) {
      expanded.classList.remove("hidden");
      expanded.classList.add("flex");
      root.setAttribute("data-ds-expanded", "true");
      root.dispatchEvent(
        new CustomEvent("recurrence:toggle", {
          detail: { expanded: true },
        }),
      );
    } else {
      expanded.classList.add("hidden");
      expanded.classList.remove("flex");
      root.setAttribute("data-ds-expanded", "false");
      root.dispatchEvent(
        new CustomEvent("recurrence:toggle", {
          detail: { expanded: false },
        }),
      );
    }
  };

  toggleBtn.addEventListener("click", toggleExpanded);

  return root;
};
